import { createMasterDataCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type PriorityDto = EntityRecord;
export type PriorityCreateRequest = EntityCreateRequest;
export type PriorityUpdateRequest = EntityUpdateRequest;

export const priorityApi: CrudApi<PriorityDto, PriorityCreateRequest, PriorityUpdateRequest> = createMasterDataCrudApi({ masterType: "priority" });
